import { useRuntimeConfig } from "nuxt/app";

export function strippedURL(link) {
  const config = useRuntimeConfig();
  const countryPrefix = config.public["storyblokCountryPrefix"];
  const countryPrefixRegexp = new RegExp(`^/?${countryPrefix}/`);
  const trailingSlashRegexp = new RegExp("/$");
  const homeRegexp = new RegExp("^/home$");
  const isString = typeof link === "string" || link instanceof String;

  let url = link;

  if (!isString) {
    url = link?.story?.url ? `${link?.story?.url}` : link?.cached_url ? `${link?.cached_url}` : `${link?.url}`;
    url = link?.anchor ? `${url}#${link?.anchor}` : url;
  }
  if (
    !url.includes("http") &&
    !url.includes("javascript") &&
    !url.includes("tel:") &&
    !url.includes("mailto:") &&
    url[0] !== "/"
  ) {
    url = "/" + url;
  }

  return url
    .replace(countryPrefixRegexp, "/")
    .replace(trailingSlashRegexp, "")
    .replace(homeRegexp, "/");
}

/** href for mailto / tel / javascript — NuxtLink strips these and leaves a dead <a>. */
export function usesNativeAnchor(link) {
  const href = strippedURL(link) || "";
  return /^(javascript:|mailto:|tel:)/i.test(href);
}

const DIDOMI_PREFERENCES_HREF =
  /^javascript:\s*Didomi\.preferences\.show\s*\(\s*\)\s*;?\s*$/i;

/**
 * Opens Didomi preferences when the CMS link is javascript:Didomi.preferences.show().
 * Safe: no eval; matches the known Storyblok footer pattern only.
 */
export function handleNativeLinkClick(event, link) {
  const href = strippedURL(link) || "";
  if (!DIDOMI_PREFERENCES_HREF.test(href)) return;

  event.preventDefault();
  if (typeof window !== "undefined") {
    (window as Window & { Didomi?: { preferences?: { show?: () => void } } })
      .Didomi?.preferences?.show?.();
  }
}
